module.exports = __webpack_public_path__ + "static/media/first.8ad7c4e2.jpeg";